import React from "react";
import { View } from "react-native";
import { Button } from "react-native-elements";

const applyButtonDefaults = (buttonStyle) => {
  const values = { ...buttonStyle };

  values.borderRadius = values.borderRadius ? values.borderRadius : 20;
  values.height = values.height ? values.height : 50;
  values.width = values.width ? values.width : 175;

  return values;
};

const applyDefaults = (style) => {
  const values = { ...style };
  return values;
};

const ButtonElement = ({
  disabled,
  title,
  onPress,
  raised = true,
  buttonStyle,
  titleStyle,
  containerStyle,
}) => (
  <View>
    <Button
      disabled={disabled}
      title={title}
      onPress={onPress}
      raised={raised}
      buttonStyle={applyButtonDefaults(buttonStyle)}
      titleStyle={applyDefaults(titleStyle)}
      containerStyle={applyDefaults(containerStyle)}
    />
  </View>
);

export default ButtonElement;
